// Firebase Services Index
// This file exports all Firebase-related services

import firebaseService from "./FirebaseService";
import { firebaseApp } from "./firebaseApp";

// Export the main Firebase service
export { default as firebaseService } from "./FirebaseService";
export { default as feedbackFirebaseService } from "./FeedbackFirebaseService";
export { default as downloadService } from "./DownloadService";

// Export Firebase app instance
export { firebaseApp };

// Export individual methods for backwards compatibility with existing code
export const fetchFirebaseToken = (setTokenFound) =>
  firebaseService.fetchAndRegisterToken(setTokenFound);

export const applySafariPushAlertToken = (pushAlertSubscriberId) =>
  firebaseService.registerSafariToken(pushAlertSubscriberId);

export const getOrRegisterServiceWorker = () =>
  firebaseService.getOrRegisterServiceWorker();

export const onMessageListener = (callback) => {
  let unsubscribeFn = null;

  // Call the async method and store the unsubscribe function
  firebaseService.onMessageListener(callback).then((unsub) => {
    unsubscribeFn = unsub;
  });

  // Return a synchronous cleanup function
  return () => {
    if (unsubscribeFn && typeof unsubscribeFn === "function") {
      unsubscribeFn();
    }
  };
};

// Export as default for convenience
export default firebaseService;

/**
 * Firebase Service Usage Examples:
 *
 * // Using the service instance
 * import firebaseService from '@/services/firebase';
 * const token = await firebaseService.fetchAndRegisterToken(setTokenFound);
 *
 * // Using individual methods (backwards compatibility)
 * import { fetchFirebaseToken, onMessageListener } from '@/services/firebase';
 * await fetchFirebaseToken(setTokenFound);
 * const unsubscribe = onMessageListener((payload) => console.log(payload));
 *
 * // Using Firebase app instance
 * import { firebaseApp } from '@/services/firebase';
 * const storage = getStorage(firebaseApp);
 */
